<template lang="pug">
.col-md-4.news-morelist
  a.photo.mb-3(
    v-if="item.photo",
    :style="{ backgroundImage: 'url(' + item.photo.image + ')' }"
  )
  span.text-black-50.small {{ formatDate(item.created) }}
  a
    h5 {{ item.title }}
  span.text-black-50.small.mr-2
    font-awesome-icon.mr-1(:icon="['fas', 'eye']") 
    | {{ item.view_count }}
  span.text-black-50.small
    font-awesome-icon.mr-1(:icon="['fas', 'share-alt']") 
    | {{ item.share_count }}
</template>

<script>
import moment from "moment";

export default {
  name: "AnnouncementItem",
  props: {
    item: Object,
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM,DD,YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.news-morelist h5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.news-morelist .photo {
  display: block;
  height: 165px;
  background-size: auto 110%;
  background-position: center center;
  background-repeat: no-repeat;
  transition: all 0.3s;

  &:hover {
    background-size: auto 120%;
  }
}

@media only screen and (max-width: 959px) {
  .news-morelist .photo,
  .news-morelist .photo:hover {
    background-size: cover;
  }
}
</style>
